import * as React from 'react';

import type { SOVPostKeyword, StoryKeyword } from 'types';

import './mention-card-keywords.scss';

type Props = {
  items: Array<StoryKeyword> | Array<SOVPostKeyword> | undefined,
  matchedSearchTerms: Array<string>,
  type: string,
  prefix: string
};

class MentionCardKeywords extends React.PureComponent<Props> {
  checkMatch(value: string): boolean {
    const { matchedSearchTerms } = this.props;
    const regex = new RegExp(`(^[#|@]?${value}$)`, 'gi');

    return (matchedSearchTerms || []).some(term => regex.test(term));
  }

  sortItemsByHighlighted(): Array<StoryKeyword> {
    const { items } = this.props;

    const highlighted = (items || []).filter(item => this.checkMatch(item.value));
    const standard = (items || []).filter(item => !this.checkMatch(item.value));

    return highlighted.concat(standard);
  }

  wrapHighlightedValue(value: string): React.ReactNode {
    return (
      <span className="mention-card-keywords__highlighted">
        {value}
      </span>
    );
  }

  render() {
    const { type, prefix } = this.props;
    const keywords = this.sortItemsByHighlighted();

    return keywords.map((item, index) => (
      <span
        key={`item-${type}-${item.value}-${index}`}
        className="mention-card-keywords__section-item"
        data-qa="mention-card-keywords__item"
      >
        {
          this.checkMatch(item.value)
            ? this.wrapHighlightedValue(`${prefix}${item.value}`)
            : `${prefix}${item.value}`
        }
      </span>
    ));
  }
}

export default MentionCardKeywords;
